import {Pipe, PipeTransform} from '@angular/core';
import {TtmStatus} from '../classes/ttmstatus';
import {Ttm} from '../classes/ttm';
import {Workorder} from '../classes/workorder';
import {TtmTypes} from '../classes/ttm-types.enum';

@Pipe({
    name: 'ttmStatus'
})
export class TtmStatusPipe implements PipeTransform {

    transform(statuses: TtmStatus[], ttm: Ttm, workorder?: Workorder, limit?: number, ...tracks: any): TtmStatus[] {
        const successiveStatusKeys = ttm.status.successive.map(s => s.key);
        return statuses.filter(status => {
            const isChecking = workorder?.soort === 'CONTROLE';
            if (ttm.type_key === TtmTypes.other && status.key === 'turned_down') {
                return true;
            }
            if (isChecking) {
                return status.for_check || status.for_any;
            }
            const filterByPermanent = ttm.type_key !== TtmTypes.permanent_signs || status.for_permanent;
            const filterByRolling = ttm.type_key !== TtmTypes.rolling_equipment || status.for_rolling_equipment;
            const filterByCurrent = status.key !== ttm.status_key;
            const filterByCheck = !status.for_check;
            const filterByPreviousOrAny = ttm.status.successive.map(s => s.key).includes(status.key) || status.for_any;

            return filterByPermanent && filterByRolling && filterByCurrent && filterByCurrent && filterByCheck && filterByPreviousOrAny;
        })
            .sort((a, b) =>
                (successiveStatusKeys.includes(a.key) ? ttm.status.successive.find(s => s.key === a.key).pivot.order : a.order + 100) -
                (successiveStatusKeys.includes(b.key) ? ttm.status.successive.find(s => s.key === b.key).pivot.order : b.order + 100)
            )
            .slice(0, limit);
    }

}
